import React, { Component } from "react";
import "./ExperienceCard.css";
import { Fade } from "react-reveal";

class ExperienceCard extends Component {
  render() {
    const experience = this.props.experience;
    const index = this.props.index;
    const totalCards = this.props.totalCards;
    const theme = this.props.theme;
    
    return (
      <div
        className="experience-list-item"
        style={{ marginTop: index === 0 ? 30 : 50 }}
      >
        <Fade left duration={1000} distance="40px">
          <div className="experience-card-logo-div">
            <div className="modern-logo-wrapper">
              <img
                className="experience-card-logo modern-logo"
                src={require(`../../assets/images/${experience["logo_path"]}`)}
                alt=""
              />
              <div className="modern-logo-glow"></div>
            </div>
          </div>
        </Fade>
        
        <div className="experience-card-stepper">
          <div
            className="modern-stepper-dot"
            style={{
              backgroundColor: "#09a271",
            }}
          />
          {index !== totalCards - 1 && (
            <div
              className="modern-stepper-line"
              style={{
                background: `linear-gradient(to bottom, #09a271, #1f2937)`,
              }}
            />
          )}
        </div>
        
        <Fade right duration={1000} distance="40px">
          <div style={{ display: "flex", flexDirection: "row" }}>
            <div
              className="experience-card modern-card"
              style={{ background: `${theme.body}` }}
            >
              <div className="modern-card-gradient"></div>
              <div className="modern-card-content">
                <div className="modern-header-section">
                  <div className="modern-title-section">
                    <h3
                      className="experience-card-title modern-title"
                      style={{ color: theme.text }}
                    >
                      {experience["title"]}
                    </h3>
                    <p
                      className="experience-card-company modern-company"
                      style={{ color: "#09a271" }}
                    >
                      <a
                        href={experience["company_url"]}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ color: "#09a271" }}
                      >
                        {experience["company"]}
                        <span className="modern-link-icon">↗</span>
                      </a>
                    </p>
                  </div>
                  <div className="modern-meta-section">
                    <div className="experience-card-heading-right">
                      <p
                        className="experience-card-duration modern-duration"
                        style={{ color: theme.secondaryText }}
                      >
                        <span className="modern-meta-icon"></span>
                        {experience["duration"]}
                      </p>
                      <p
                        className="experience-card-location modern-location"
                        style={{ color: theme.secondaryText }}
                      >
                        <span className="modern-meta-icon"></span>
                        {experience["location"]}
                      </p>
                    </div>
                  </div>
                </div>
                
                <div className="modern-description-wrapper">
                  <div className="repo-description" />
                  <ul className="modern-description-list">
                    {Array.isArray(experience.description) ? (
                      experience.description.map((item, idx) => (
                        <li key={idx} className="modern-description-item" style={{ color: theme.text }}>
                          <span className="modern-bullet"></span>
                          {item}
                        </li>
                      ))
                    ) : (
                      <li className="modern-description-item" style={{ color: theme.text }}>
                        <span className="modern-bullet"></span>
                        {experience.description}
                      </li>
                    )}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </Fade>
      </div>
    );
  }
}

export default ExperienceCard;